import { render, staticRenderFns } from "./node-settings-overlay.vue?vue&type=template&id=19b8f764&scoped=true&"
import script from "./node-settings-overlay.vue?vue&type=script&lang=ts&"
export * from "./node-settings-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./node-settings-overlay.vue?vue&type=style&index=0&id=19b8f764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8f764",
  null
  
)

export default component.exports